import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * Generate request config for admin requests with locale and region support
 *
 * @param param - The request config, locale and region
 * @returns The request config with locale and region headers
 */
export var getReqConfig = function getReqConfig(_ref) {
  var locale = _ref.locale,
    region = _ref.region,
    config = _ref.config;
  return _extends({}, config, {
    headers: _extends({
      'Accept-Language': locale,
      Region: region
    }, config === null || config === void 0 ? void 0 : config.headers)
  });
};

/**
 * Parse the pagination response from admin API
 *
 * @param param - The pagination response
 * @returns The parsed pagination object
 */
export var parsePagination = function parsePagination(_ref2) {
  var limit = _ref2.limit,
    offset = _ref2.offset,
    totalResults = _ref2.totalResults;
  return {
    limit: limit,
    offset: offset,
    totalResults: totalResults,
    hasNext: totalResults > limit + offset
  };
};

/**
 * Get all data from admin API based on pagination
 *
 * @param fn - The function to get data from admin API
 * @param param - The data key
 * @returns The concat data returned from admin API
 */
export var getAllData = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(fn, _ref3) {
    var dataKey, results, hasNext, offset, limit, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dataKey = _ref3.dataKey;
          results = [];
          hasNext = true;
          offset = 0;
          limit = 200;
        case 5:
          if (!hasNext) {
            _context.next = 14;
            break;
          }
          _context.next = 8;
          return fn({
            limit: limit,
            offset: offset
          });
        case 8:
          response = _context.sent;
          results = results.concat(response[dataKey]);
          hasNext = response.pagination.hasNext;
          if (hasNext) offset += limit;
          _context.next = 5;
          break;
        case 14:
          return _context.abrupt("return", results);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getAllData(_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();